import styled from "styled-components";

export const Main = styled.div`
  height: 60px;
  width: 60px;
`;
